<template>
    <div class="warranty mt-4">
        <div :class="{
                'input-focus-effect': true,
                'rv-valiadate-input-form': error
            }">
            <input :class="warranty !== '' ? 'border-primary' : ''" type="text" id="inputWarranty"
                v-model="warranty" @focus="e => e.target.select()" inputmode="numeric"/>
            <label :class="{
                    'mb-0': true,
                    'input-on-alue': warranty !== ''
                }">Bảo hành (tháng)</label>
        </div>
        <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
    </div>
</template>
<script>
export default {
    props: ['data', 'error'],
    data() {
        return {
            warranty: ''
        }
    },
    watch: {
        data(val){
            this.warranty = this.$formatNumber(val);
        },
        warranty(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.warranty = this.$formatNumber(this.data);
    }
}
</script>
